<template>
  <div
    class="check-list-person auto-list_col_centered"
    @click.stop="$emit('open')"
  >
    <el-popover
      v-if="responseHandleName && responseHandleDate"
      placement="top-start"
      :title="getDateOfCertainFormat(responseHandleDate)"
      width="200"
      trigger="hover"
      :content="responseHandleName"
    >
      <div slot="reference">
        <p v-if="responseStatus" class="date" :class="getColor">
          {{ getStatus }}
        </p>
      </div>
    </el-popover>
    <div v-else>
      <p v-if="responseStatus" class="date" :class="getColor">
        {{ getStatus }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  statusColorInProgress,
  statusResponsInProgress,
} from '@/views/LoadDay/Components/constants'

export default {
  name: 'Date',
  props: {
    responseStatus: {
      type: String,
      default: 'not_handled',
    },
    responseHandleDate: {
      type: String,
      default: 'not_handled',
    },
    responseHandleName: {
      type: String,
      default: 'not_handled',
    },
  },
  data() {
    return {
      statusResponsInProgress,
      colorStatus: null,
    }
  },
  computed: {
    getStatus() {
      return this.responseStatus && statusResponsInProgress[this.responseStatus]
        ? statusResponsInProgress[this.responseStatus]
        : ''
    },
    getColor() {
      return this.responseStatus && statusColorInProgress[this.responseStatus]
        ? statusColorInProgress[this.responseStatus]
        : ''
    },
  },
}
</script>

<style lang="sass">
.el-popover
  font-family: 'Rubik', sans-serif!important
  color: #1B1E24
  font-size: 12px
  line-height: 14px
  margin: 10px 0
.bids-list .middle-section .check-list .check-list-person
  .date
    font-size: 15px
    line-height: 14px
    color: #8694A4
    margin: 10px 0
    &.status
      text-decoration: underline
    &.info
      color: #909399
    &.success
      color: #67C23A
    &.warning
      color: #E6A23C
    &.danger
      color: #F56C6C
</style>
